import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";

export default function CurrentContractType({ searchObject, onChange, t }) {
  const [contractTypes, setContractTypes] = useState([]);

  useEffect(() => {
    CommonService.getContractType().then((data) => setContractTypes(data));
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Current Contract Type")}</legend>
      <Select
        className="form-select fontsize-legend"
        onChange={onChange}
        value={searchObject.currentContractTypeId || ""}
        name="currentContractTypeId"
      >
        <option value=""></option>
        {contractTypes.map((contract) => (
          <option
            className="fontsize-legend"
            key={contract.id}
            value={contract.id}
          >
            {t(contract.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
